import auth from 'src/auth';
import type { CoamResponseType, PermissionEntry } from '@rendering/web-client';
import { getSdk } from 'src/sdk';

export type MappedCoamResponse = Record<string, string[]>;

export function extractResourceIdentifiers(permissionEntries: PermissionEntry[] = []): string[] {
    return permissionEntries
        .filter((value) => value.permissions.includes('create:scenes'))
        .map((value) => value.identifier);
}

export function mapCoamResponse(coamResponse: CoamResponseType): MappedCoamResponse {
    const keys = Object.keys(coamResponse);

    const mappedCoamResponse: MappedCoamResponse = {};
    keys.forEach((key) => {
        const identifiers = extractResourceIdentifiers(coamResponse[key]);
        if (identifiers.length) {
            mappedCoamResponse[key] = identifiers;
        }
    });
    return mappedCoamResponse;
}

/**
 * Retrieves an array of merchants and fulfillers that the principal has access to.
 * @returns {object} - The promise of the request.
 */
export function getResources(): Promise<MappedCoamResponse> {
    const { sub } = auth.getProfile();
    return getSdk().Settings.getCOAMPermissions(sub).then(mapCoamResponse);
}
